// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .content {
  background-color: #ffffff;
  background-image: url('beerhive_logo_brown_app_v2.fcae9e65659c6c72.png');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center center;
  background-size: 80%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
